/* MUI */
import { Alert, AlertTitle, Grid, Typography } from '@mui/material';

/* Shared */
import { Notify } from 'application/Shared/Helpers';

/* React */
import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { withTranslation } from 'react-i18next';

class Policies extends Component {
    constructor(props) {
        super(props);
        this.state = { loaded: false };
    }

    componentDidMount() {
        this.setState({ loaded: true });
    }

    render() {
        const { t } = this.props;
        const { loaded } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <>
                <Typography color="textSecondary" fontWeight={600}>
                    {t('Extension.Policies.deploying.title')}
                </Typography>
                <br />
                {t('Extension.Policies.deploying.description')}
                <hr />
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <Typography color="textSecondary" fontWeight={600}>
                            {t('Extension.Policies.deploying.chrome')}
                        </Typography>
                        <br />
                        <CopyToClipboard
                            text={process.env.REACT_APP_CHROME_POLICY}
                            onCopy={() => {
                                Notify.success(t('Common.copied'));
                            }}
                        >
                            <Alert
                                icon={false}
                                severity="success"
                                sx={{
                                    backgroundColor: 'scripts.backgroundColor',
                                    borderColor: 'scripts.borderColor',
                                    cursor: 'pointer',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                <AlertTitle sx={{ color: 'scripts.color' }}>
                                    {t('Common.click_to_copy')}
                                </AlertTitle>
                                <Typography variant="codeBlock">
                                    {process.env.REACT_APP_CHROME_POLICY}
                                </Typography>
                            </Alert>
                        </CopyToClipboard>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography color="textSecondary" fontWeight={600}>
                            {t('Extension.Policies.deploying.chrome.value')}
                        </Typography>
                        <br />
                        <CopyToClipboard
                            text={process.env.REACT_APP_CHROMIUM_URL}
                            onCopy={() => {
                                Notify.success(t('Common.copied'));
                            }}
                        >
                            <Alert
                                icon={false}
                                severity="success"
                                sx={{
                                    backgroundColor: 'scripts.backgroundColor',
                                    borderColor: 'scripts.borderColor',
                                    cursor: 'pointer',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                <AlertTitle sx={{ color: 'scripts.color' }}>
                                    {t('Common.click_to_copy')}
                                </AlertTitle>
                                <Typography variant="codeBlock">
                                    {process.env.REACT_APP_CHROMIUM_URL}
                                </Typography>
                            </Alert>
                        </CopyToClipboard>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography color="textSecondary" fontWeight={600}>
                            {t('Extension.Policies.deploying.edge')}
                        </Typography>
                        <br />
                        <CopyToClipboard
                            text={process.env.REACT_APP_EDGE_POLICY}
                            onCopy={() => {
                                Notify.success(t('Common.copied'));
                            }}
                        >
                            <Alert
                                icon={false}
                                severity="success"
                                sx={{
                                    backgroundColor: 'scripts.backgroundColor',
                                    borderColor: 'scripts.borderColor',
                                    cursor: 'pointer',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                <AlertTitle sx={{ color: 'scripts.color' }}>
                                    {t('Common.click_to_copy')}
                                </AlertTitle>
                                <Typography variant="codeBlock">
                                    {process.env.REACT_APP_EDGE_POLICY}
                                </Typography>
                            </Alert>
                        </CopyToClipboard>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography color="textSecondary" fontWeight={600}>
                            {t('Extension.Policies.deploying.edge.value')}
                        </Typography>
                        <br />
                        <CopyToClipboard
                            text="fbgiiopidibajnhdbmfcbgjkdmehhjck"
                            onCopy={() => {
                                Notify.success(t('Common.copied'));
                            }}
                        >
                            <Alert
                                icon={false}
                                severity="success"
                                sx={{
                                    backgroundColor: 'scripts.backgroundColor',
                                    borderColor: 'scripts.borderColor',
                                    cursor: 'pointer',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                <AlertTitle sx={{ color: 'scripts.color' }}>
                                    {t('Common.click_to_copy')}
                                </AlertTitle>
                                <Typography variant="codeBlock">
                                    fbgiiopidibajnhdbmfcbgjkdmehhjck
                                </Typography>
                            </Alert>
                        </CopyToClipboard>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography color="textSecondary" fontWeight={600}>
                            {t('Extension.Policies.deploying.firefox')}
                        </Typography>
                        <br />
                        <CopyToClipboard
                            text={process.env.REACT_APP_CHROMIUM_URL}
                            onCopy={() => {
                                Notify.success(t('Common.copied'));
                            }}
                        >
                            <Alert
                                severity="success"
                                icon={false}
                                sx={{
                                    backgroundColor: 'scripts.backgroundColor',
                                    borderColor: 'scripts.borderColor',
                                    cursor: 'pointer',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                <AlertTitle sx={{ color: 'scripts.color' }}>
                                    {t('Common.click_to_copy')}
                                </AlertTitle>
                                <Typography variant="codeBlock">
                                    {process.env.REACT_APP_FIREFOX_POLICY}
                                </Typography>
                            </Alert>
                        </CopyToClipboard>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography color="textSecondary" fontWeight={600}>
                            {t('Extension.Policies.deploying.firefox.value')}
                        </Typography>
                        <br />
                        <CopyToClipboard
                            text={process.env.REACT_APP_FIREFOX_URL}
                            onCopy={() => {
                                Notify.success(t('Common.copied'));
                            }}
                        >
                            <Alert
                                severity="success"
                                icon={false}
                                sx={{
                                    backgroundColor: 'scripts.backgroundColor',
                                    borderColor: 'scripts.borderColor',
                                    cursor: 'pointer',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                <AlertTitle sx={{ color: 'scripts.color' }}>
                                    {t('Common.click_to_copy')}
                                </AlertTitle>
                                <Typography variant="codeBlock">
                                    {process.env.REACT_APP_FIREFOX_URL}
                                </Typography>
                            </Alert>
                        </CopyToClipboard>
                    </Grid>
                </Grid>
            </>
        );
    }
}
export default withTranslation()(Policies);
